import React from 'react';

/*
This wrapper prevents rehydration issues when
using server-side rendering on gatsby builds.
See: https://www.joshwcomeau.com/react/the-perils-of-rehydration/
*/
const ClientOnly = ({ children, ...delegated }) => {
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  return <div {...delegated}>{children}</div>;
};

export default ClientOnly;
